import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || 'https://4trip-server.trrip.live/api',
  timeout: 30000, // 30 seconds timeout
});

// Request interceptor for logging
api.interceptors.request.use(
  (config) => {
    console.log(`[API Request] ${config.method.toUpperCase()} ${config.url}`, {
      data: config.data,
      params: config.params,
    });
    return config;
  },
  (error) => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// Response interceptor for logging
api.interceptors.response.use(
  (response) => {
    console.log(`[API Response] ${response.status} ${response.config.url}`, response.data);
    return response;
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      console.error('[API Timeout Error] Request took too long (>30s)');
    } else if (error.message === 'Network Error') {
      console.error('[API Network Error] Potential CORS issue or internet loss');
    } else {
      console.error('[API Response Error]', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        config: error.config,
      });
    }
    return Promise.reject(error);
  }
);

export default api;
